var _style, _path, _path2, _path3, _line, _path4, _line2, _path5, _path6, _path7, _path8, _line3, _line4, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostureWalking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,8.5c0,0-0.6-3.8,1.6-4.8c1-0.5,3.2-1.1,4.8,1.2c0.5,0.8,1.2,4-1.1,5.7c0,0-2.1,1.5-4.3-0.4 C19.7,10.3,18.9,9.4,18.6,8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,10.4l1.2-1.5V7.3c0,0-0.2-0.7,0.8-0.7c1,0,3,0,3,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,25c0,0-2.9-1.1-2.9-4.6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.8,
    y1: 19.2,
    x2: 11.8,
    y2: 18.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,17c0,0,2-1.1,1.5-2.5c-0.4-0.7-1.4-1.7-2.8-0.5c-0.5,0.7-1.9,2.3-1.9,2.3s-0.5,0.4-0.8,1.3 c-0.3,0.9-1.1,2.4-1.1,2.4s-0.6,1.5,0,2.3c0.5,0.4,1.5,0.6,2.1-1S17.5,18.4,19.4,17z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 17.3,
    x2: 17,
    y2: 15.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,17.8l1.3,1.4c0,0,2,0.3,1.8,1.6c-0.1,0.5-0.2,1.6-1.9,1.1l-1.2-0.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,34.5l-1.6-5.4c0,0-0.4-1.7-1.1-2.8s-1.6-3.6-1.6-3.6v-6.3c0,0-0.1-2.9-2.9-4.3c-0.5-0.2-3-0.5-2.9,3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,20.4l-1,7.4c0,0-0.1,1.3-0.9,2.1c-0.8,0.8-3.1,4.2-3.1,4.2l1.9,0.9l4.1-3.8c0,0,0.7-0.5,0.8-1.4 s0.7-4,0.7-4s-0.1-1.6,0.7,0c0.5,0.9,1.9,2.6,1.9,2.6s0.4,0.2,0.6,1s2,6,2,6s3.7-1.4,4.5,0c0.4,0.6,1.6,1.6-0.3,1.8 c-1.9,0.2-2.9,0.3-2.9,0.3S25,38.1,25,35.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,35.3c0,0,0.8,0.8,0.8,1.7c0,0.3,0.5,1.2-1.8,0.4c-1.1-0.4-2.7-1.2-2.7-1.2s-1.1-0.2,1.2-2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.7,
    y1: 22.7,
    x2: 23.2,
    y2: 22.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.5,
    y1: 12.9,
    x2: 21.8,
    y2: 11.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,12.1c0,0,0.3-0.6,0.6-1.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureWalking);
export default __webpack_public_path__ + "static/media/PostureWalking.21fa8d8a0ad36b71b06c2daa73c4d819.svg";
export { ForwardRef as ReactComponent };